import { ReportFilters } from "../components/tc-admin/reports/Reports.Component";
import ReportDataModel from "../data-models/Report.DataModel";
import { apiGet } from '../support/helpers/ApiConnection.Helper';

export function getReport(reportFilters: ReportFilters, abortSignal: AbortSignal): Promise<Array<ReportDataModel>> {   
    let querystring = '';
    if(reportFilters.tenantId){
        querystring += `TenantId=${reportFilters.tenantId}`;
    }
    if(reportFilters.adjusterId){
        if(querystring.length > 0){
            querystring += '&&';
        }
        querystring += `AdjusterId=${reportFilters.adjusterId}`;
    }
    if(reportFilters.vendorId){
        if(querystring.length > 0){
            querystring += '&&';
        }
        querystring += `VendorId=${reportFilters.vendorId}`;
    }
    if(reportFilters.dateRangeFrom){
        if(querystring.length > 0){
            querystring += '&&';
        }
        querystring += `DateRangeFrom=${reportFilters.dateRangeFrom}`;
    }
    if(reportFilters.dateRangeTo){
        if(querystring.length > 0){
            querystring += '&&';
        }
        querystring += `DateRangeTo=${reportFilters.dateRangeTo}`;
    }

    return apiGet<Array<ReportDataModel>>('/reports/filtered-reports',abortSignal, querystring);
}
